<template>
    <div v-if="loaded">
        <div class="command">
            <div>
                Potenza Kw<br>
                <selectBox :items="options.power" @changed="onPowerChange" />
            </div>
            <div>
                Condumo kW/anno<br>
                <input type="text" :value="this.consumoF1" v-on:input="onConsumoF1ChangeInput" /> F1<br>
                <input type="text" :value="this.consumoF2" v-on:input="onConsumoF2ChangeInput" /> F2-F3
            </div>
            <div>
                Condumo Smc/anno<br>
                <input type="text" :value="consumoGas" v-on:input="onConsumoGasChangeInput" /><br>
            </div>
            <div>
                Regione di residenza<br>
                <selectBox :items="options.region" @changed="onRegionChange" />
            </div>
            <div>
                Cap di residenza<br>
                <input type="text" value="">
            </div>
            <div>
                Residente/non residente<br>
                <selectBox :items="options.resident" @changed="onResidentChange" />
            </div>
        </div>

        <div class="result">
            <gas :consumo="consumoGas" :potenza="power" :regione="region" />
        </div>

        <div class="result">
            <luce :product="link" :consumoF1="consumoF1" :consumoF2="consumoF2" :potenza="power" :resident="resident" />
        </div>

        <div class="result">
            <luce :product="sceltasicura" :consumoF1="consumoF1" :consumoF2="consumoF2" :potenza="power" :resident="resident" />
        </div>
        
    </div>
</template>

<script>

import SelectBox from '../elements/SelectBox.vue';
import Gas from '../components/Gas.vue';
import Luce from '../components/Luce.vue';

import { Link, Sceltasicura } from "../model/Products.js";

import OptionsResident from "../model/OptionsResident.js";
import { OptionsConsumptionGas, OptionsConsumptionLuce } from "../model/OptionsConsumption.js";
import OptionsPower from "../model/OptionsPower.js";
import OptionsRegion from "../model/OptionsRegion.js";

export default {
    name: "DevTool",
    components: {
        SelectBox,
        Gas,
        Luce
    },
    props: {

    },
    data() {
        return {
            loaded: false,
            options: {
                consumo: [],
                power: [],
                region: [],
                resident: []
            },
            consumo: {
                gas: 0,
                luce: 0
            },
            consumoGas:0,
            consumoF1: 0,
            consumoF2: 0,
            power: 0,
            region: ''
        };
    },
    mounted() {

        this.link = new Link;
        this.sceltasicura = new Sceltasicura;

        //- set init consumptions ---
            this.options.consumo.gas = OptionsConsumptionGas;
            console.log( 'DevTool mounted consumo ', this.options.consumo.gas.length, this.options.consumo.gas );
            if (this.options.consumo.gas.length){
                console.log( 'DevTool mounted consumo set ', this.options.consumo.gas[0].value );
                this.consumoGas = Number( this.options.consumo.gas[0].value );
            }

            this.options.consumo.luce = OptionsConsumptionLuce;
            console.log( 'DevTool mounted consumo ', this.options.consumo.luce.length, this.options.consumo.luce );
            if (this.options.consumo.luce.length){
                console.log( 'DevTool mounted consumo set ', this.options.consumo.luce[0].value );
                this.consumoF1 = Number( this.options.consumo.luce[0].value );
                this.consumoF2 = Number( this.options.consumo.luce[0].value );
            }

        //- set init power ---
            this.options.power = OptionsPower;
            console.log( 'DevTool mounted power ', this.options.power.length, this.options.power );
            if (this.options.power.length){
                console.log( 'DevTool mounted power set ', this.options.power[0].value );
                this.power = Number( this.options.power[0].value );
            }
        
        //- set init region ---
            this.options.region = OptionsRegion;
            console.log( 'DevTool mounted region ', this.options.region.length, this.options.region );
            if (this.options.region.length){
                console.log( 'DevTool mounted region set ', this.options.region[0].value );
                this.region = this.options.region[0].value;
            }

            this.options.resident = OptionsResident;
            console.log( 'DevTool mounted resident ', this.options.resident.length, this.options.resident );
            if (this.options.resident.length){
                console.log( 'DevTool mounted resident set ', this.options.resident[0].value );
                this.resident = this.options.resident[0].value;
            }

        //- init completed display data ---
            this.loaded = true;
    },
    computed: {
            
    },
    methods: {
        onConsumoGasChangeInput( elem ){
            console.log( elem.srcElement );
            this.consumoGas = Number( elem.srcElement.value );
        },

        onConsumoF1ChangeInput( elem ){
            console.log( elem.srcElement );
            this.consumoF1 = Number( elem.srcElement.value );
        },

        onConsumoF2ChangeInput( elem ){
            this.consumoF2 = Number( elem.srcElement.value );
        },

        onPowerChange( elem ){
            this.power = Number( elem.val );
        },

        onRegionChange( elem ){
            this.region = elem.val;
        },

        onResidentChange( elem ){
            this.resident = elem.val;
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .command {display: flex; font-size: 11px; position: fixed; right: 0; left: 0; top:0; background: #B34B9A; z-index: 100; box-shadow: 0 0 9px #ccc; color: #fff;}
    .command > div { padding: 15px;}
</style>